import React from "react";
import Autocomplete from '@material-ui/lab/Autocomplete';
import {TextField} from "@material-ui/core";

const AutoComplete = (props) => {
    const {id, ...defaultProps } = props;

    return (<Autocomplete
        {...defaultProps}
        id={id}
        autoSelect
        renderInput={(params) => <TextField {...params} label="autoSelect" margin="normal"/>}
    />);
}

export default AutoComplete;
